<template>
  <div class="page-content original-dialog">
    <div class="monthly-closing">
      <h1 class="page-title">{{ $locale("monthlyClosing.monthlyClosing") }}</h1>

      <!-- Search Area -->
      <el-row
        class="search-area"
        :gutter="10"
      >
        <el-col
          :span="15"
        >
          <MonthPickerGroup
              :start="filter.startMonth"
              :end="filter.endMonth"
              @setFatherDate="getDate_fn"
          ></MonthPickerGroup>
          <el-button
              class="egl-btn-yellow"
              @click="search_fn"
          >
            {{ $locale("global.search") }}
          </el-button>
        </el-col>
        <el-col
          class="ta-r"
          :span="9"
        >
          <el-button
            class="egl-btn-yellow right-align-btn"
            @click="openDialog"
          >
            {{ $locale("monthlyClosing.monthlyClosing") }}
          </el-button>
          <el-button
            :class="notApprove ? 'egl-btn-yellow' : 'egl-btn-gray'"
            :disabled="!notApprove"
            @click="approve_fn"
            class="right-align-btn">
              {{ $locale("global.approve") }}
          </el-button>
        </el-col>
      </el-row>

      <el-table
        class="egl-table list-table result-table"
        :row-class-name="({row}) => {return row.status !== 'active' ? '' : 'disable'}"
        :data="tableData"
      >

        <el-table-column
          width="80"
          align="center"
          :label="$locale('global.change')"
        >
          <template
            slot-scope="scope"
          >
            <i
              class="el-icon-circle-check change"
              v-show="!scope.row.approve">
            </i>
          </template>
        </el-table-column>

        <template
          v-for="th in thead"
        >
          <el-table-column
            :min-width="180"
            :label="th.label"
            :prop="th.prop"
            :key="th.prop"
            :sortable="th.sort"
            :align="th.align">
          </el-table-column>
        </template>

        <el-table-column
          align="center"
          :label="$locale('global.control')"
        >
          <template
            slot-scope="scope"
          >
            <div
              :class="scope.row.canDelete ? '' : 'disable'"
              class="handle"
            >
              <a
                @click="delete_fn(scope.$index)"
              >
                {{ $locale("global.delete") }}
              </a>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <CommPagination
        :total="pageCount"
        :curPage="page"
        @current-change="choosePage"
      />

      <el-dialog
        class="egl-dialog"
        :visible="showDialog"
        :show-close="false"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        @opened="onDialogOpen"
      >
      <div slot="title" class="dialog-title">
        <div class="tipsBox">
          <p>{{ $locale("monthlyClosing.dialog.title")}}</p>
          <el-tooltip
            placement="top"
            :content="$locale('monthlyClosing.dialog.title')"
          >
            <span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>

      <div class="dialog-title">
        <div class="tipsBox">
          <div class="form-module-tit tipsBox">{{ $locale("global.basicInfo") }}</div>
          <el-tooltip :content="$locale('global.basicInfo')" placement="top"
            ><span class="tipIcon"></span
          ></el-tooltip>
        </div>
      </div>
      <el-form ref="form" :model="form" @validate="validate">
        <el-row
        type="flex"
        align="middle"
        :gutter="20"
        >
          <el-col
            :span="10"
          >
            <el-form-item
              prop="theaterId"
              required
              :label="$locale('monthlyClosing.dialog.theaterName')"
              :rules="[{
                required: true,
                message: 'Theater name is required'
              }]"
              :show-message="form.theaterIdDirty"
            >
              <el-select
                v-model="form.theaterId"
                :placeholder="$locale('monthlyClosing.dialog.placeholder')"
              >
                <el-option
                  v-for="item in cinemaList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="10"
          >
            <el-form-item
              prop="selectMonth"
              required
              :label="$locale('monthlyClosing.dialog.month')"
              :rules="[{
                type: 'number',
                message: 'Month is required'
              }]"
              :show-message="form.selectMonthDirty"
            >
              <div class="datepicker">
                <el-button
                  class="egl-btn-yellow"
                  @click="getCurMonth(-1)"
                >
                  <i class="el-icon-arrow-left"></i>
                </el-button>
                <el-date-picker
                  type="month"
                  v-model="form.selectMonth"
                  format="yyyy-MM"
                  value-format="timestamp"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  @change="getCurMonth(0)"
                ></el-date-picker>
                <el-button
                  class="egl-btn-yellow"
                  @click="getCurMonth(1)"
                  >
                  <i class="el-icon-arrow-right"></i>
                </el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button
            class="egl-btn-white"
            @click="closeDialog"
          >
            {{ $locale("global.backTo") }}
          </el-button>
          <el-button
            :class="canSubmit ? 'egl-btn-yellow' : 'egl-btn-gray'"
            :disabled="!canSubmit"
            class="right-align-btn"
            @click="submitForm()"
          >
            {{ $locale("monthlyClosing.dialog.save") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MonthPickerGroup from "@/components/MonthPickerGroup";
import { monthlyClosingThead, formatData } from "@/assets/js/monthlyClosing.js";
import { getMonthlyClosingList, createMonthClosing, approveMonthClosing, deleteMonthClosing } from "@/helpers/service/api/monthlyClosing.js";
import { getCinemaList } from "@/helpers/service/api/common.js";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";
import "@/assets/style/monthlyClosing.less";
import { getBrandList } from "@/helpers/service/api/brand.js";

export default {
  name: "MonthlyClosing",
  data() {
    return {
      form: {
        theaterId: "",
        selectMonth: this.$moment().valueOf(),
        theaterIdDirty: false,
        selectMonthDirty: true,
      },
      canSubmit: false,
      pickerOptions: {
        disabledDate: this.disableMonth
      },
      currentMonth: 0,
      filter: {
        startMonth: this.currentMonth,
        endMonth: this.currentMonth
      },
      notApprove: false,
      cinemaList: [],
      originalData: [],
      thead: [],
      tableData: [],
      page: 0,
      pageCount: 0,
      showDialog: false,
      dialogMsg: {},
      dialogAction: "",
      dialogData: {},
      brandName: ""
    };
  },
  methods: {
    validate(fieldName, isValid) {
      if (this.form[fieldName]) {
        this.form[fieldName + "Dirty"] = true;
      }
      const allValid = (this.$refs.form.fields || []).every(e => (e.prop === fieldName && isValid) || e.validateState === "success");
      this.canSubmit = allValid;
    },
    submitForm() {
      const all = this.form.theaterId === "all";
      let monthCloseInfo = {
        brandId: window.localStorage.getItem("brandId"),
        cinemaId: all ? "" : this.form.theaterId,
        cinemaBrandName: all ? this.brandName : this.cinemaList.filter(list => list.value === this.form.theaterId)[0].label,
        type: window.localStorage.getItem("adminType"),
        monthString: this.$moment(this.form.selectMonth).format("YYYY-MM"),
        operationId: window.localStorage.getItem("accountId"),
        operationName: window.localStorage.getItem("userName"),
      };

      createMonthClosing(all, monthCloseInfo).then(res => {
        if (res.success) {
          countDownAlert(this.$locale("global.operationSuccessful"), this.search_fn());
          this.closeDialog();
        }
      });
    },
    getCurMonth(num = 0) {
      const currentMonth = this.$moment().valueOf();
      const updatedMonth = num === 0 ? this.$moment(this.form.selectMonth).valueOf() : this.$moment(this.form.selectMonth).subtract(-(num), "months").valueOf();

      this.form.selectMonth = updatedMonth > currentMonth ? currentMonth : updatedMonth;
    },
    disableMonth(time) {
      return time.getTime() > this.$moment(this.selectMonth).startOf("month").valueOf();
    },
    search_fn() {
      const that = this;
      const requestMonth = {
        startDate: this.$moment(that.filter.startMonth).format("YYYY-MM"),
        endDate: this.$moment(that.filter.endMonth).format("YYYY-MM"),
        page: this.page,
        pageSize: 10,
        brandId: window.localStorage.getItem("brandId")
      };

      getMonthlyClosingList(requestMonth).then(res => {
        let { notApprove, tableData } = formatData(res.data.data);

        // this.pageCount = Math.ceil(res.data.count / res.data.pageSize);
        this.pageCount = res.data.count || 0;
        that.tableData = tableData;
        that.notApprove = notApprove;
        that.originalData = res.data.data;
      });
    },
    getDate_fn(obj = {}) {
      this.filter = {
        startMonth: obj.startMonth,
        endMonth: obj.endMonth,
      };
    },
    choosePage(page) {
      this.page = page - 1;
      this.search_fn();
    },
    onDialogOpen() {
      this.$refs.form.validate(() => {});
    },
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    delete_fn(index) {
      const that = this;
      let { id, cinemaBrandName } = that.tableData[index];
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${cinemaBrandName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm

        deleteMonthClosing({ id: id }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: this.search_fn() });
          }
        });
      });
    },
    approve_fn() {
      approveMonthClosing().then(res => {
        if (res.success) {
          countDownAlert({ content: this.$locale("global.operationSuccessful"), callback: this.search_fn() });
        }
      });
    },
    getCinemaList_fn() {
      getCinemaList({ page: 0, pageSize: 9999 }, false, false).then(res => {
        this.cinemaList = res.data.data.map(({ id, name }) => {
          return {
            value: id,
            label: name
          };
        });

        if(res.data.data.length > 0 && window.localStorage.getItem("adminType") === "brand") { // brand level
          this.cinemaList = [{ value: "all", label: "All" }, ...this.cinemaList];
        }
      });
    },
  },
  mounted() {
    let th = monthlyClosingThead();
    const currentDate = this.$moment().valueOf();
    this.filter = {
      startMonth: this.$moment(currentDate).subtract(6, "months").valueOf(),
      endMonth: currentDate
    };
    this.currentDate = currentDate;
    this.thead = th;
    this.getCinemaList_fn();
    this.search_fn();
    getBrandList().then(res => {
      if (res.success) {
        this.brandName = res.data.data.filter(brand => brand.id === window.localStorage.getItem("brandId"))[0].name;
      }
    });
  },
  components: {
    MonthPickerGroup,
    CommPagination,
  },
};
</script>
